import Service from './main'
import { Reference as Url } from './urls'

export default {
  getGradeReference: () => {
    return Service.get(Url.GET_GRADES_REF)
  }
}
